module.exports = __webpack_public_path__ + "static/linkedin-b5ce35b3079b7936b6a542e9bc651b21.jpg";